<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <h2 v-if="lessonId">Tasks for "{{lessonName}}"</h2>
    <h2 v-else>Please select Lesson from previous tab</h2>
    <div>
      <base-button v-if="lessonId" type="primary" @click.prevent="onNew" icon>
        <span class="btn-inner--icon">
          <i class="ni e-add"></i>
        </span>New task
      </base-button>
      <base-button v-if="lessonId" type="info" @click.prevent="onRefresh" icon>
        <span class="btn-inner--icon">
          <i class="ni refresh-02"></i>
        </span>Refresh
      </base-button>
    </div>
    <el-table :data="tableData" row-key="id" header-row-class-name="thead-light">
      <el-table-column min-width="620px">
        <template v-slot="{row}">
          <!-- <div class="d-flex justify-content-center"></div> -->
          <task-item
            :tasktype="row.tasktypename"
            :level="row.levelname"
            :description="row.description"
            :title="row.title"
            :orderindex="row.orderindex"
            :files="row.files"
          ></task-item>
        </template>
      </el-table-column>
      <el-table-column min-width="120px" align="right" label="Actions">
        <div slot-scope="{$index, row}" class="d-flex">
          <base-button
            @click.native="onEdit($index, row)"
            class="edit"
            type="warning"
            size="sm"
            icon
          >
            <i class="text-white ni n-edit"></i>
          </base-button>
          <base-button
            @click.native="onDelete($index, row)"
            class="remove btn-link"
            type="danger"
            size="sm"
            icon
          >
            <i class="text-white ni e-remove"></i>
          </base-button>
        </div>
      </el-table-column>
    </el-table>

    <modal :show.sync="modalform" size="lg" bodyClasses="modalbody">
      <h6 slot="header" class="modal-title">Task action</h6>
      <el-tabs type="card" v-model="activeTab" ref="tabs">
        <el-tab-pane label="Info" name="tab1">
          <validation-observer ref="formvalid">
            <div class="row">
              <div class="col-lg-8">
                <base-input
                  name="title"
                  rules="required"
                  v-model="task.title"
                  class="mb-3"
                  label="Title"
                  placeholder="Title"
                ></base-input>
              </div>
              <div class="col-lg-4">
                <base-input label="Task type">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="task.tasktype"
                    placeholder="Level"
                  >
                    <el-option
                      class="select-primary"
                      v-for="(item,index) in tasktypes"
                      :key="index"
                      :label="item"
                      :value="index + 1"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <base-input label="Description" class="mr-1">
                  <textarea class="form-control" rows="3" resize="none" v-model="task.description"></textarea>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <base-input label="Level">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="task.level"
                    placeholder="Level"
                  >
                    <el-option
                      class="select-primary"
                      v-for="(item,index) in levels"
                      :key="index"
                      :label="item"
                      :value="index + 1"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-lg-6">
                <base-input
                  v-model="task.orderindex"
                  type="number"
                  placeholder="Order"
                  label="Order index"
                  max="100"
                  min="0"
                ></base-input>
              </div>
            </div>
          </validation-observer>
          <div class="text-center">
            <base-button type="success" @click.native="onSaveStage(1)">Save and close</base-button>
            <base-button type="primary" @click.native="onSaveStage(2)">Save and go to files</base-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Files" name="tab2" :disabled="!task.id">
          <upload :sourcetype="1" :sourceId="task.id"></upload>
        </el-tab-pane>
      </el-tabs>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import { Table, TableColumn, Select, Option, Tabs, TabPane } from "element-ui";
import { Modal, BaseAlert } from "@/components";
import TaskItem from "./TaskItem";
import { LessonTaskType } from "../../../services/types";
import Upload from "../Upload";

import {
  GetLessonTasks,
  GetLessonTask,
  DeleteLessonTask,
  CreateLessonTask,
  UpdateLessonTask,
} from "../../../services/courses";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "tasks",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    TaskItem,
    Modal,
    HtmlEditor,
    Loading,
    Upload,
  },
  computed: {
    mode() {
      return this.task.id ? "Edit" : "Create";
    },
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      lessonId: "",
      lessonName: "",
      modalform: false,
      task: {},
      tasktypes: ["in class", "homework"],
      levels: ["Easy", "Normal", "Hard"],
      activeTab: "tab1",
    };
  },
  methods: {
    loadTasks() {
      this.isLoading = true;
      this.tableData = [];
      GetLessonTasks(this.lessonId).then((response) => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.tableData = response.data.result;
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onNew() {
      this.task = new LessonTaskType();
      this.task.lessonId = this.lessonId;
      this.modalform = true;
      this.activeTab = "tab1";
    },
    onEdit(index, row) {
      this.task = Object.assign({}, row);
      this.modalform = true;
      this.activeTab = "tab1";
    },
    onSaveStage(status) {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (this.mode === "Create") {
            CreateLessonTask(this.task).then((response) => {
              this.isLoading = false;
              if (response.data.result !== undefined) {
                if (status == 1) this.modalform = false;
                else {
                  this.notifyVue("success");
                  this.task.id = response.data.result;
                  this.activeTab = "tab2";
                }
                this.loadTasks();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            UpdateLessonTask(this.task).then((response) => {
              this.isLoading = false;
              if (response.data.result !== undefined) {
                this.modalform = false;
                this.loadTasks();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        }
      });
    },
    onRefresh() {
      this.loadTasks();
    },
    onDelete(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            DeleteLessonTask(row.id).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.loadTasks();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        });
    },
  },
  watch: {
    lessonId: function () {
      this.loadTasks();
    },
  },
};
</script>
<style>
.modalbody {
  min-height: 500px;
}
</style>